import React from 'react';
import './Prompt.css';

const Output = ({ outputdata }) => {
  const renderListItem = (item, index) => {
    const { key, value } = item;
    
    return (
      <div key={index} className='sub-content-heading'>
        {key && <strong>{key}</strong>}
        {value && (
          Array.isArray(value) ? (
            <ol className='sub-content-points'>
              {value.map((val, idx) => (
                <li key={idx}>{`${idx + 1}. ${val}`}</li>
              ))}
            </ol>
          ) : (
            <span className='sub-content-points'>{value}</span>
          )
        )}
      </div>
    );
  };

  const renderSection = (section, index) => (
    <div key={index} className="output-section">
      <div className='key-heading'>{section.key}</div>
      <div className='sub-content'>
        <div className='sub-content-box'>
          {section.value.map((item, idx) => renderListItem(item, idx))}
        </div>
      </div>
    </div>
  );

  if (!outputdata) {
    return <p>No data available</p>;
  }

  return (
    <div className="output-container">
      {outputdata.map((section, index) => renderSection(section, index))}
    </div>
  );
};

export default Output;